import Modifier from 'ember-modifier';
import { service } from '@ember/service';

export default class FocusIfMediumUpBreakpointModifier extends Modifier {
  @service media;

  modify(element) {
    if (this.media.isLargeUp) {
      setTimeout(() => {
        element.focus();
      });
    }
  }
}
